import { formatPaymentMonth, PaymentRound } from '../objects/PaymentRound';

angular.module("tromanWeb").directive("ergoYearmonth", [function () {

    const pmre = /(\d\d\d\d)-(0[1-9]|1[0-2])/;

    return {
        restrict: "A",
        require: '?ngModel',
        link: function (scope, _element, attributes, ctrl) {
            if (!ctrl) return;

            let round = null;
            scope.$watch(attributes.ergoYearmonth, function (value) {
                if (value instanceof PaymentRound) {
                    round = value;
                } else {
                    round = null;
                }
                ctrl.$validate();
            });

            ctrl.$validators.yearmonth = function (mv) {
                if (mv == null) return false;
                if (round == null) return true;

                if (mv.year < round.Year) return false;
                if (mv.year > round.Year) return true;

                return mv.month > round.Month;
            };

            ctrl.$formatters.push(val => {
                if (val && (0 <= val.year && val.year <= 9999) && (1 <= val.month && val.month <= 12)) {
                    return formatPaymentMonth(val.year, val.month);
                }
                return "";
            });

            ctrl.$parsers.push(val => {
                const m = pmre.exec(val);
                if (m) {
                    return {
                        year: parseInt(m[1]),
                        month: parseInt(m[2])
                    };
                }
            });
        }
    };
}]);
